const updateActionsStore = {
  toastr: 'Updated action',
  toastrError1: 'Not authorized (Created by another user)',
  toastrError2: 'Not authorized (You are not amongst the accountables)',
  toastrError3: 'Not authorized',
};

export default updateActionsStore;
